import { render, staticRenderFns } from "./TxnCompleted.vue?vue&type=template&id=d69312c0&scoped=true&"
import script from "./TxnCompleted.vue?vue&type=script&lang=js&"
export * from "./TxnCompleted.vue?vue&type=script&lang=js&"
import style0 from "./TxnCompleted.vue?vue&type=style&index=0&id=d69312c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d69312c0",
  null
  
)

export default component.exports